import { getHeaders } from './common';

export const fetchPolicyGroups = async (orgId) => {
  try {
    if (!orgId) return { success: false, error: "Organization ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/policy_by_org?orgid=${orgId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      const activeGroups = data.filter(policy => policy.status === "Active");
      return { success: true, data: activeGroups };
    } else {
      console.error("Failed to fetch policy groups.");
      return { success: false, error: "Failed to fetch policy groups" };
    }
  } catch (error) {
    console.error("Error fetching policy groups:", error);
    return { success: false, error: error.message };
  }
};


export const fetchPolicyDevices = async (policyId) => {
  try {
    if (!policyId) return { success: false, error: "Policy ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/devices_by_policy?PolicyId=${policyId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch policy devices.");
      return { success: false, error: "Failed to fetch policy devices" };
    }
  } catch (error) {
    console.error("Error fetching policy devices:", error);
    return { success: false, error: error.message };
  }
};


export const createPolicyGroup = async (policyData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/create_policy`,
      {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(policyData),
        credentials: "include",
      }
    );

    if (response.ok) {
      
      return { success: true, message: "Policy group created successfully" };
    } else {
      console.error("Failed to create policy group.");
      return { success: false, error: "Failed to create policy group" };
    }
  } catch (error) {
    console.error("Error creating policy group:", error);
    return { success: false, error: error.message };
  }
};


export const updatePolicyGroup = async (policyData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/update_policy`,
      {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(policyData),
        credentials: "include",
      }
    );

    if (response.ok) {
      
      return { success: true, message: "Policy group updated successfully" };
    } else {
      console.error("Failed to update policy group.");
      return { success: false, error: "Failed to update policy group" };
    }
  } catch (error) {
    console.error("Error updating policy group:", error);
    return { success: false, error: error.message };
  }
};


export const deletePolicyGroup = async (policyId) => {
  try {
    if (!policyId) return { success: false, error: "Policy ID is required" };
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/delete_policy/${policyId}`,
      {
        method: "DELETE",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      return { success: true, message: "Policy group deleted successfully" };
    } else {
      console.error("Failed to delete policy group.");
      return { success: false, error: "Failed to delete policy group" };
    }
  } catch (error) {
    console.error("Error deleting policy group:", error);
    return { success: false, error: error.message };
  }
};


export const addDeviceToPolicy = async (deviceId, policyId) => {
  try {
    if (!deviceId || !policyId) {
      return { success: false, error: "Device ID and Policy ID are required" };
    }
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/add_device_to_policy?id=${deviceId}&PolicyId=${policyId}`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.status === 500) {
      const errorData = await response.json();
      return { success: false, error: errorData.detail || "An error occurred" };
    } else if (response.ok) {
      return { success: true, message: "Device added to policy group successfully" };
    } else {
      console.error(`Failed to add device ${deviceId} to policy group.`);
      return { success: false, error: "Failed to add device to policy group" };
    }
  } catch (error) {
    console.error("Error adding device to policy:", error);
    return { success: false, error: error.message };
  }
};


export const removeDeviceFromPolicy = async (deviceId, policyId) => {
  try {
    if (!deviceId || !policyId) {
      return { success: false, error: "Device ID and Policy ID are required" };
    }
    
    const response = await fetch(
      `${process.env.REACT_APP_POLICY_API_URL}/remove_device_from_policy?id=${deviceId}&PolicyId=${policyId}`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      return { success: true, message: "Device removed from policy group successfully" };
    } else {
      console.error("Failed to remove device from policy group.");
      return { success: false, error: "Failed to remove device from policy group" };
    }
  } catch (error) {
    console.error("Error removing device from policy:", error);
    return { success: false, error: error.message };
  }
};